(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.errorMap = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var ERROR_MAP = exports.ERROR_MAP = {
    contacts: {
      type: 'empty',
      text: '无vivo账号联系人',
      image: 'https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/484bbfe0-31f0-11ee-9b0e-4124cbfa4a8c.gif',
      darkImage: 'https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/a14393b0-34cb-11ee-a2e6-ff6273b5537f.gif'
    },
    content: {
      type: 'empty',
      text: '无内容',
      image: 'https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/095c1b00-31ef-11ee-9e36-c15762846016.gif',
      darkImage: 'https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/52cb5a30-34ce-11ee-a2e6-ff6273b5537f.gif'
    },
    download: {
      type: 'empty',
      text: '无下载内容',
      image: 'https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/12a2d570-34f4-11ee-a2e6-ff6273b5537f.gif',
      darkImage: 'https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/aa454360-34f2-11ee-8314-c51481d7a20d.gif'
    },
    // file: {
    //   type: 'empty',
    //   text: '无文件',
    //   image:
    //     'https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/5c1879e0-040c-11ed-bce9-abb2543b4b80.png',
    //   darkImage:
    //     'https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/80545b50-0080-11ee-bba0-bd717d777cbd.png',
    // },
    image: {
      type: 'empty',
      text: '无图片',
      image: 'https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/a02a68b0-31f0-11ee-bdfc-5f15dc269fac.gif',
      darkImage: 'https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/a0290920-31f0-11ee-8af8-0311b199d914.gif'
    },
    // map: {
    //   type: 'empty',
    //   text: '本机未安装地图<br/>（支持百度地图、高德地图）',
    //   image:
    //     'https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/b1ddd000-611a-11eb-afaa-5981b84ad185.png',
    //   darkImage:
    //     'https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/b1ddd000-611a-11eb-afaa-5981b84ad185.png',
    // },
    message: {
      type: 'empty',
      text: '无信息',
      image: 'https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/d6a92f90-31f3-11ee-8af8-0311b199d914.gif',
      darkImage: 'https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/d3c83040-34d3-11ee-8b2d-6fcde82c71b3.gif'
    },
    video: {
      type: 'empty',
      text: '无视频',
      image: 'https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/89f36850-34f0-11ee-8b2d-6fcde82c71b3.gif',
      darkImage: 'https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/ccec8120-34e9-11ee-9e36-c15762846016.gif'
    },
    unstable: {
      type: 'network',
      text: '网络不稳定，点击页面刷新',
      image: 'https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/3218a470-31ed-11ee-9b0e-4124cbfa4a8c.gif',
      darkImage: 'https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/89470940-34d0-11ee-a272-a7cb55011448.gif'
    },
    anomaly: {
      type: 'network',
      text: '网络异常，请检查网络连接。',
      image: 'https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/c8877ac0-4099-11ee-b043-839c63d126b3.gif',
      darkImage: 'https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/ff04dc40-34ce-11ee-bba0-bd717d777cbd.gif'
    },
    unauth: {
      type: 'network',
      text: 'WLAN网络未认证，请检查网络连接',
      image: 'https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/c8877ac0-4099-11ee-b043-839c63d126b3.gif',
      darkImage: 'https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/ff04dc40-34ce-11ee-bba0-bd717d777cbd.gif'
    },
    unavailable: {
      type: 'network',
      text: '当前网络不可用，请检查网络连接',
      image: 'https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/ee3aae10-31ec-11ee-8af8-0311b199d914.gif',
      darkImage: 'https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/b01046d0-34d1-11ee-9e36-c15762846016.gif'
    },
    unconnected: {
      type: 'network',
      text: '网络未连接，无法获取数据',
      image: 'https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/ee3aae10-31ec-11ee-8af8-0311b199d914.gif',
      darkImage: 'https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/b01046d0-34d1-11ee-9e36-c15762846016.gif'
    },
    error: {
      type: 'server',
      text: '服务器异常，请稍后再试',
      image: 'https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/c8877ac0-4099-11ee-b043-839c63d126b3.gif',
      darkImage: 'https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/ff04dc40-34ce-11ee-bba0-bd717d777cbd.gif'
    },
    nopending: {
      type: 'empty',
      text: '无待办',
      image: 'https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/1c24b810-31ee-11ee-9b0e-4124cbfa4a8c.gif',
      darkImage: 'https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/ccef8e60-34e9-11ee-a2e6-ff6273b5537f.gif'
    },
    nosearch: {
      type: 'empty',
      text: '无搜索结果',
      image: 'https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/c3932810-31ef-11ee-a2e6-ff6273b5537f.gif',
      darkImage: 'https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/40171430-34ea-11ee-8314-c51481d7a20d.gif'
    },
    nodetail: {
      type: 'empty',
      text: '无详情',
      image: 'https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/928ea560-31f3-11ee-a272-a7cb55011448.gif',
      darkImage: 'https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/d5a24440-34cf-11ee-8314-c51481d7a20d.gif'
    },
    nomusic: {
      type: 'empty',
      text: '无音乐',
      image: 'https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/43483150-31f4-11ee-88e2-1bb1cf1d109f.gif',
      darkImage: 'https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/434746f0-31f4-11ee-bdfc-5f15dc269fac.gif'
    },
    novivoid: {
      type: 'empty',
      text: '无账号',
      image: 'https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/46c12b70-31f4-11ee-bba0-bd717d777cbd.gif',
      darkImage: 'https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/733cf370-34ea-11ee-bdfc-5f15dc269fac.gif'
    },
    nosimcard: {
      type: 'empty',
      text: '无SIM卡',
      image: 'https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/4ab485b0-31f4-11ee-88e2-1bb1cf1d109f.gif',
      darkImage: 'https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/4a9df070-31f4-11ee-b043-839c63d126b3.gif'
    }
  };
});